import { useEffect, useState } from "react";
import AuthService from "../../../../../api/AuthService";
import BankHomePage from "../../../../../entities/DashboardPage/AccountingModule/BankPage/BankHomePage";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";

function BankHome() {
  const [page, setPage] = useState(0);
  const [data, setData] = useState([]);
  const [cashAccount, setCashAccount] = useState({});
  const [transactionStats, setTransactionStats] = useState({
    total: 0,
    deposits: 0,
    withdrawals: 0,
  });
  const [total, setTotal] = useState();

  useEffect(() => {
    // TODO: API call to fetch transaction data for the day and update the trasaction details.
    const dummyTransactionData = {
      total: 420,
      deposits: 220,
      withdrawals: 200,
    };

    setTransactionStats(dummyTransactionData);
  }, []);

  useEffect(() => {
    getAllBanks("", "", page);
  }, [page]);

  useEffect(() => {
    getCashAccount();
  }, []);

  const getAllBanks = async (txt, sort, page) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.handleGetAllCompanyBankAccount(
        txt,
        sort,
        page
      );
      if (result?.success) {
        setData(result?.data?.bankAccounts);
        setTotal(result?.data?.total);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getCashAccount = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleGetCashAccount();
      if (result?.success) {
        setCashAccount(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleFilter = (text, sort) => {
    text ? getAllBanks(text) : sort ? getAllBanks("", sort) : null;
  };
  return (
    <BankHomePage
      data={data}
      page={page}
      setPage={setPage}
      total={total}
      handleFilter={handleFilter}
      transactionStats={transactionStats}
      cashAccount={cashAccount}
    />
  );
}

export default BankHome;
